<template>
  <div>
    <the-company :intro="intro" />
    <the-history :data="history" />
    <the-culture />
    <the-tree :class="$style.tree" />
    <the-entry :data="entry" />
  </div>
</template>

<script>
import TheCompany from '@/components/TheCompany'
import TheHistory from '@/components/TheHistory'
import TheCulture from '@/components/TheCulture'
import TheTree from '@/components/TheTree'
import TheEntry from '@/components/TheEntry'

export default {
  components: { TheCompany, TheHistory, TheCulture, TheTree, TheEntry },
  async asyncData({ app, $winstonLog }) {
    let introData = ''
    let historyData = {}

    // 公司简介
    try {
      const intro = await app.$axios.get('/wbhome/aboutUs')
      introData = (intro.data && intro.data.data) || ''
    } catch ({ response }) {
      const { status, statusText, config } = response || {}
      $winstonLog.error(`${new Date()} ${config.url} ${status} ${statusText}`)
    }

    // 发展历程
    try {
      const history = await app.$axios.get('/wbhome/development')
      historyData = (history.data && history.data.data) || {}
    } catch ({ response }) {
      const { status, statusText, config } = response || {}
      $winstonLog.error(`${new Date()} ${config.url} ${status} ${statusText}`)
    }

    return {
      intro: introData,
      history: historyData,
    }
  },
  data() {
    return {
      entry: ['join', 'honor', 'game', 'business'],
    }
  },
}
</script>

<style lang="less" module>
.tree {
  @media screen and (max-width: @mini-width) {
    display: none;
  }
}
</style>
